export default __webpack_public_path__ + "/dist/images/list-search-icon.5590468cbe92ec7d676b9de61a6b5c09.svg";